import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Radio } from "lucide-react";
import { Panel } from "@/components/common/Panel";
import { EngineHero } from "@/components/common/EngineHero";
import { EngineFindingsTable } from "@/components/common/FindingDetailSheet";
import { staggerItem } from "@/lib/motion";
import { api } from "@/lib/api";

const RULES = [
    { label: "Service lacks authorization annotations", category: "Missing Authorization Validation" },
    { label: "Weak backend (DPC_EXT) implementation", category: "Weak Backend Implementation" },
    { label: "EntitySet exposed without a check", category: "Missing AUTHORITY-CHECK" },
];

export default function OData() {
    const [findings, setFindings] = useState([]);
    useEffect(() => {
        (async () => {
            const { data } = await api.get("/findings", { params: { engine: "odata" } });
            setFindings(data);
        })();
    }, []);

    const totals = useMemo(
        () => findings.reduce((acc, f) => ({ ...acc, [f.category]: (acc[f.category] || 0) + 1 }), {}),
        [findings],
    );

    return (
        <div className="space-y-6">
            <EngineHero
                testId="odata-engine-hero"
                icon={Radio}
                engine="OData"
                title="Gateway · MPC_EXT · DPC_EXT · Authorization"
                blurb="Parses EDMX/SEGW metadata and inspects the exposed surface of every EntitySet and EntityType, validating that the backend data-provider extension actually enforces authorization through annotations and AUTHORITY-CHECK statements rather than relying on the gateway alone."
                rules={RULES}
                totals={totals}
            />

            <motion.div variants={staggerItem} initial="initial" animate="animate">
                <Panel eyebrow={`${findings.length} findings`} title="OData Findings" testId="odata-findings-panel">
                    <EngineFindingsTable findings={findings} emptyHint="Upload OData metadata (EDMX) and run analysis." />
                </Panel>
            </motion.div>
        </div>
    );
}
